import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiKeyQueryKeys, APIKeys } from '#api';

export function useAddAPIKey() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: APIKeys.addAPIKey,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: apiKeyQueryKeys.lists() });
    },
  });
}

export function useEditAPIKey() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: APIKeys.editAPIKey,
    onSuccess: (apiKey) => {
      void queryClient.invalidateQueries({ queryKey: apiKeyQueryKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: apiKeyQueryKeys.detail(apiKey.id) });
    },
  });
}
